/* eslint-disable import/prefer-default-export */
import { CLEAR_NOTIFICATION, DISPLAY_NOTIFICATION } from './types';

export const displayNotification = ({ message, type }) => ({
  type: DISPLAY_NOTIFICATION,
  payload: {
    message,
    type,
  },
});

export const clearNotification = {
  type: CLEAR_NOTIFICATION,
};
